<template>
    <div class="multiselect-blade-selected-item-wrapper">
        <div class="multiselect-blade-selected-item">
            <pendo-icon
                v-if="optionIcon"
                :type="optionIcon.type"
                :fill="optionIcon.fill"
                :stroke="optionIcon.stroke"
                size="16" />
            <span class="multiselect-blade-selected-item-label">{{ label }}</span>
        </div>
        <div
            v-if="sublabel.length"
            class="selected-item-app">
            <span class="accent-text">in</span>
            <pendo-icon
                v-if="computedAppIcon"
                :type="computedAppIcon.type"
                :fill="computedAppIcon.fill"
                :stroke="computedAppIcon.stroke"
                size="16" />
            {{ sublabel }}
        </div>
    </div>
</template>

<script>
import { PendoIcon } from '@pendo/components';
import lowerFirst from 'lodash/lowerFirst';

export default {
    components: {
        PendoIcon,
    },
    props: {
        icon: {
            type: [String, Object],
            default: '',
        },
        sublabel: {
            type: String,
            default: '',
        },
        label: {
            type: String,
            default: '',
        },
        appIcon: {
            type: [String, Object],
            default: '',
        },
    },
    computed: {
        optionIcon () {
            if (typeof this.icon === 'string') {
                const icon = this.icon === 'extension' ? 'puzzle-piece' : this.icon;

                return { type: lowerFirst(icon) };
            }

            return this.icon;
        },
        computedAppIcon () {
            if (typeof this.appIcon === 'string') {
                return { type: this.appIcon, stroke: 'var(--palette-gray-70)' };
            }

            return { stroke: 'var(--palette-gray-70)', ...this.appIcon };
        },
    },
};
</script>

<style lang="less" scoped>
.multiselect-blade-selected-item-wrapper {
    overflow: hidden;
    font-size: 14px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 8px;

    .multiselect-blade-selected-item {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        gap: 8px;
        align-items: center;
    }

    .selected-item-app {
        display: flex;
        flex-direction:row;
        align-items: center;
        gap: 8px;
        color: var(--palette-gray-70);
    }
}
</style>
